// extracted by mini-css-extract-plugin
export default {"cartDashboard":"Mix6tnqfJuiiFBRA0K8D","emptyCart":"futmRSXLAia6xFSJa08D","submitting":"hmf1e0CGVSQ2Z7C2q17z","showMore":"VtTF3I6he6WOpsq5PgaQ"};